<!-- 基金持仓 -->
<template>
  <div v-if="showHold" class="fund-hold">
    <!-- 顶部标题栏 -->
    <div class="header row">
      <div class="title row" @click="goFundHold">
        <div>基金持仓</div>
        <img :src="RIGHT_ARROW" class="right-arrow"/>
      </div>
      <!-- 季报入口 -->
      <div v-if="isShowQuarterly" class="quarterly" @click="goReport"
        >{{ quarterlyText }}</div>
    </div>
    <!-- 图表 -->
    <div class="chart">
      <hold-tab-switch
        :cur-index="curIndex"
        :tab-list="tabList"
        @clickTab="(e) => { this.curIndex=e.index}" />
      <div class="chart-box">
        <component
          :is="chartType"
          :curTab="curTab"
          :data-source="chartDataSource.data ? chartDataSource.data || [] : chartDataSource || []"
          :polar-html="polarHtml"
          :chart-size="chartSize"
          :is-more-than-hundred="chartDataSource.isMoreThanHundred || false"
          :is-diff-scale="isDiffScale"
          ref="chart" />
      </div>
    </div>
    <!-- 净值提醒 -->
    <div v-if="!$isEmpty(netAssetTipText) && curIndex !== tabList.length -1"
      class="net-asset-tip"
      >{{netAssetTipText}}</div>
    <!-- 持仓列表 -->
    <component
      v-if="!$isEmpty(listConfig) && !$isEmpty(listConfig.data) && !$isEmpty(listConfig.data.list)"
      :is="listConfig.compName"
      :data-source="listConfig.data" />
    <!-- 开户提醒 -->
    <div class="open-account" @click="$goFundApp"
      >在线开户万2.5佣金，即刻参与基金重仓股行情！</div>
  </div>
</template>

<script>
import CONFIG from '@/configs/default';
import FundRingChart from './FundRingChart.vue';
import HoldTabSwitch from './HoldTabSwitch.vue';
import FundHoldLegend from './FundHoldLegend.vue';
import IndustryPointChart from './IndustryPointChart.vue';
import ScaleBarChart from './ScaleBarChart.vue';
import HeavyStockList from './HeavyStockList.vue';
import HoldCurrencyList from './HoldCurrencyList.vue';
import HeavyFundList from './HeavyFundList.vue';
import HeavyBondList from './HeavyBondList.vue';

export default {
  name: 'fund-hold',

  components: {
    HoldTabSwitch,
    FundRingChart,
    FundHoldLegend,
    IndustryPointChart,
    ScaleBarChart,
    HeavyStockList,
    HoldCurrencyList,
    HeavyFundList,
    HeavyBondList,
  },

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      curIndex: 0, // 当前选中tab
      listConfig: {}, // 持仓列表数据
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    showHold() {
      return !this.basicInfo?.isNewFund;
    },
    isShowQuarterly() { // 是否展示季报入口
      return !this.basicInfo?.isCurrencyFund
        && !this.basicInfo?.isNetValueManageWealthCurrencyFund
        && !this.$isEmpty(this.detailInfo?.quarterlyInfo);
    },
    quarterlyText() { // 季报入口文案
      const quarterlyInfo = this.detailInfo?.quarterlyInfo || {};
      if (!this.$isEmpty(quarterlyInfo?.WARNNUM) && quarterlyInfo?.WARNNUM > 0) {
        // 1 年报 2 半年报 3 季报
        const config = {
          1: '年报',
          2: '中报',
          3: '季报',
        };
        return `${quarterlyInfo?.WARNNUM}个${config[quarterlyInfo.STYLE]}关注点 >`;
      }
      return '查看巡检报告 >';
    },
    tabList() { // tab列表
      const {
        isCurrencyFund,
        isFofFund,
        isBondFund,
      } = this.basicInfo || {};
      const { heavyStockRatio } = this.detailInfo || {};
      if (isCurrencyFund) return CONFIG.fundHoldTabList.currency;
      if (isFofFund) return CONFIG.fundHoldTabList.fof;
      if (isBondFund
        && (this.$isEmpty(heavyStockRatio) || parseFloat(heavyStockRatio) < 5)) {
        return CONFIG.fundHoldTabList.bond;
      }
      return CONFIG.fundHoldTabList.default;
    },
    curTab() { // 当前选中tab
      return this.tabList[this.curIndex] || {};
    },
    chartType() {
      return this.getChartType();
    },
    chartDataSource() { // 图表数据源
      const data = this.getChartData();
      return data;
    },
    netAssetsInfo() { // 净资产
      return this.detailInfo?.netAssetsInfo || {};
    },
    isDiffScale() { // 规模是否与净资产不一致
      const fundSizeData = this.detailInfo?.fundSizeData || {};
      const fundSize = fundSizeData?.fundSize || '';
      const netValue = this.netAssetsInfo.netAssetsValue || '';
      return !this.$isEmpty(fundSize) && !this.$isEmpty(netValue) && fundSize !== netValue;
    },
    chartSize() { // 图表尺寸
      const sizeMap = {
        'fund-ring-chart': { width: '141px', height: '141px' },
        'scale-bar-chart': { width: '100%', height: '200px' },
      };
      return sizeMap[this.curTab?.chartType] || {};
    },
    polarHtml() { // 饼图中心显示内容
      return `<div style="width: 100px;text-align: center;">
        <div style="font-family: DINAlternate-Bold;font-size: 14px;line-height: 18px;">${this.netAssetsInfo?.netAssets || '--'}</div>
        <div style="font-size: 12px;line-height: 22px;color: #999999;">净资产</div>
        <div style="font-size: 12px;line-height: 14px;color: #999999;">${this.netAssetsInfo?.netAssetsDate || ''}</div>
      </div>`;
    },
    netAssetTipText() { // 净资产提示
      return this.detailInfo?.netAssetsInfo?.netAssetTipText || '';
    },
  },

  watch: {
    chartDataSource: {
      handler() {
        if (!this.$isEmpty(this.chartDataSource)) {
          setTimeout(() => {
            if (typeof this.$refs.chart?.initChart === 'function') {
              this.$refs.chart.initChart();
            }
          }, 150);
        }
      },
      immediate: true,
    },
    detailInfo: {
      handler() {
        this.getListConfig();
      },
      immediate: true,
    },
  },

  methods: {
    goFundHold() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.jjcc.click', '');
      this.$goFundApp();
    },
    goReport() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.jb.click', '');
      this.$goFundApp();
    },
    // 图表类型
    getChartType() {
      if (this.curTab.value === 'industry') {
        const { bType, feature, establishDate } = this.basicInfo || {};
        const now = new Date().getTime();
        const days = (now - Date.parse(establishDate)) / 1000 / 60 / 60 / 24;
        if (['01', '21', '24', '04'].indexOf(bType) >= 0 && feature.indexOf('031') < 0 && days > 365) {
          return 'industry-point-chart';
        }
      }
      return this.curTab?.chartType || '';
    },

    // 图表数据
    getChartData() {
      if (this.curTab.value === 'asset') {
        return this.basicInfo?.isCurrencyFund ? this.detailInfo?.currencyAssetsData || {}
          : this.detailInfo?.assetsData || {};
      }
      if (this.curTab.value === 'industry') { // 处理行业数据
        const { bType, feature, establishDate } = this.basicInfo || {};
        const now = new Date().getTime();
        const days = (now - Date.parse(establishDate)) / 1000 / 60 / 60 / 24;
        if (['01', '21', '24', '04'].indexOf(bType) >= 0 && feature.indexOf('031') < 0 && days > 365) {
          return this.detailInfo?.pointChartData || {};
        }
        return this.detailInfo?.industryData;
      }
      const valueMap = {
        scale: 'fundSizeData',
        classify: 'classificationData',
        bondType: 'couponTypeData',
        industry: 'industryData',
      };
      const valueKey = valueMap[this.curTab.value] || '';
      const data = this.$isEmpty(valueKey) ? { data: [], type: this.curTab.value }
        : this.detailInfo[valueKey];
      return data;
    },

    // 列表数据
    async getListConfig() {
      if (this.$isEmpty(this.basicInfo)
        || this.$isEmpty(this.detailInfo)
        || !this.$isEmpty(this.listConfig)) { return; }
      let compName = 'HeavyStockList';
      let data = this.detailInfo?.heavyStockListInfo || {};
      const {
        isCurrencyFund,
        isFofFund,
        isBondFund,
        isETFFeederFund,
      } = this.basicInfo;
      const { heavyStockRatio } = this.detailInfo || {};
      if (isCurrencyFund) { // 货币基金
        data = this.detailInfo?.currencyListInfo || {};
        compName = 'HoldCurrencyList';
      }
      if (isFofFund) { // FOF
        data = this.detailInfo?.FOFHeavyFundList || {};
        compName = 'HeavyFundList';
      }
      if (isETFFeederFund) { // ETF联结重仓基金
        data = this.detailInfo?.ETFFeederHeavyFundList || {};
        compName = 'HeavyFundList';
      }
      if (isBondFund // 债券
        && (this.$isEmpty(heavyStockRatio) || parseFloat(heavyStockRatio) < 5)) {
        data = this.detailInfo?.heavyBondListInfo || {};
        compName = 'HeavyBondList';
      }
      if (compName === 'HeavyBondList' || compName === 'HeavyStockList') { // 重仓股票和债券需要拉取市场信息
        await this.handleMarketInfo(data);
      }
      this.listConfig = { data, compName };
      console.log('===> listConfig', this.listConfig);
    },

    // 处理市场信息
    async handleMarketInfo(listInfo) {
      if (this.$isEmpty(listInfo) || this.$isEmpty(listInfo?.list)) return;
      // 处理东财接口请求参数
      let params = '';
      const list = listInfo?.list || [];
      list.forEach((item) => {
        params += `${item.newMarketCode}.${item.code},`;
      });
      // 拉接口
      let indexRes = [];
      try {
        // ETF基金 海外用户延迟
        // TODO 海外用户
        const wbp2u = this.basicInfo?.isETF ? '' : '';
        const result = await this.$http.useRequests('StokeApi.getIndexData', {
          secids: params,
          wbp2u,
          fields: 'f1,f2,f3,f4,f12,f13,f14,f29,f292',
          fltt: 2,
          invt: 2,
        });
        if (result.data && result.data.diff && result.data.diff.length) {
          indexRes = result.data.diff;
        } else {
          indexRes = [];
        }
      } catch (error) {
        indexRes = [];
      }
      const formatList = this.handleListMarketInfo(list, indexRes);
      this.$set(listInfo, 'list', formatList);
    },

    handleListMarketInfo(list, marketList) {
      const temp = [];
      list.forEach((element) => {
        const index = marketList.findIndex((item) => item.f12 === element.code);
        const item = { ...element };
        if (index >= 0) {
          item.price = this.$isEmpty(marketList[index].f2) || marketList[index].f2 === '-'
            ? '--'
            : `${Number(marketList[index].f2).toFixed(2)}`;
          item.priceRatio = this.$isEmpty(marketList[index].f3) || marketList[index].f3 === '-'
            ? '--'
            : `${Number(marketList[index].f3).toFixed(2)}%`;
          // 直接使用证券@马文豹提供的参数市场号f13，按照数字进行自定义转换，0-深交所，1-上交所，116(128）港交所，105纳斯达克，106纽交所，107美交所。
          if ([116, 128].indexOf(marketList[index].f13) >= 0) {
            item.marketTag = 'HK';
          }
          if ([105, 106, 107].indexOf(marketList[index].f13) >= 0) {
            item.marketTag = 'US';
          }
          // 停牌  @马文豹f292是6或14的时候是停牌
          if ([6, 14].indexOf(marketList[index].f292) >= 0) {
            item.marketTip = '停牌';
          }
        }
        temp.push(item);
      });
      return temp;
    },
  },
};
</script>

<style lang="less" scoped>
.row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.fund-hold {
  width: 100%;
  border-top: 1px solid #eeeeee;
  padding: 32px 0 32px 24px;
  box-sizing: border-box;
  background-color: #ffffff;
  border-radius: 0 0 12px 12px;
  .header {
    justify-content: space-between;
    .title {
      font-size: 32px;
      color: #000000;
      line-height: 44px;
      font-weight: bold;
      .right-arrow {
        width: 32px;
        height: 32px;
        margin-left: 8px;
      }
    }
    .quarterly {
      background-color: rgba(0, 138, 255, 0.1);
      border-radius: 100px 0 0 100px;
      font-family: PingFangSC-Medium;
      font-size: 24px;
      color: #008aff;
      text-align: right;
      padding: 16px 28px;
    }
  }
  .chart {
    margin-top: 32px;
    margin-right: 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .chart-box {
      // background-color: wheat;
      padding: 40px 12px 0;
      width: 100%;
      box-sizing: border-box;
      align-items: flex-start;
      justify-content: center;
    }
  }
  .net-asset-tip {
    color: #999999;
    font-size: 28px;
    line-height: 42px;
    padding: 40px 30px 20px 30px;
  }
  .open-account {
    margin-top: 24px;
    margin-right: 24px;
    padding-top: 24px;
    border-top: 1px solid #eeeeee;
    font-size: 24px;
    color: #3A90FA;
  }
}
</style>
